import { CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { ChunkErrorHandler } from './services/chunk-error-handler';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './auth.component';
import { LayoutComponent } from './layout.component';
import { FooterComponent } from './components/footer/footer/footer.component';
import { HeaderComponent } from './components/header/header/header.component';
import { provideHttpClient, withInterceptorsFromDi, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { USERWITHROLE_COMPONENTS } from './components/security/userwithrole.module.component';
import { ANGULAR_MATERIAL_MODULES, ANGULAR_MATERIAL_COMPONENTS } from './angular.material.modules';

import { LoginComponent } from './modules/login/components/login.component';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { IDSAuthService } from './services/idsauth.service';
import { CommonService } from './services/common.service';
import { DisplayHtmlContentCommonComponent } from './components/display-html-content-common/display-html-content-common.component';
import { ToastrModule } from 'ngx-toastr';
import { JWTInterceptor } from './services/jwt.interceptor.service';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { CacheService } from './services/cache.service';
import { UsermanagementModule } from './modules/usermanagement/usermanagement.module';
import { CommonDialogComponent } from './components/common-dialog/components/common-dialog/common-dialogcomponent';
import { RoleBasedRedirectComponent } from './components/role-based-redirect/role-based-redirect.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { SchedulerModule } from '@progress/kendo-angular-scheduler';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    LayoutComponent,
    FooterComponent,
    HeaderComponent,
    ANGULAR_MATERIAL_COMPONENTS,
    CommonDialogComponent,
    LoginComponent,
    RoleBasedRedirectComponent,
    AccessDeniedComponent,
    USERWITHROLE_COMPONENTS
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    MatCheckboxModule,
    MatDialogModule,
    MatIconModule
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    UsermanagementModule,
    BrowserAnimationsModule,
    ...ANGULAR_MATERIAL_MODULES,
    ToastrModule.forRoot({ positionClass: 'toast-bottom-right' }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    DisplayHtmlContentCommonComponent,
    // SchedulerModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()),
    CommonService,
    IDSAuthService,
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    CacheService,
    { provide: ErrorHandler, useClass: ChunkErrorHandler }
  ]
})
export class AppModule { }
